import { render, staticRenderFns } from "./SlidingBannerIndex.vue?vue&type=template&id=2441772f"
import script from "./SlidingBannerIndex.vue?vue&type=script&lang=ts"
export * from "./SlidingBannerIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports